import giftOption from '../components/giftOption';

giftOption.init();
